import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { supabase } from "../../lib/supabase";

export default function RedefinirSenha() {
  const navigate = useNavigate();
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const [success, setSuccess] = useState(false);
  const [hasToken, setHasToken] = useState(false);

  useEffect(() => {
    // Verificar se tem token na URL (vem apos o #)
    const hash = window.location.hash;
    if (hash && hash.includes("access_token")) {
      setHasToken(true);
      
      // O Supabase automaticamente processa o token do hash
      // quando usamos getSession apos o redirect
      supabase.auth.getSession().then(({ data: { session } }) => {
        if (!session) {
          setError("Link expirado ou invalido. Solicite um novo link de recuperacao.");
          setHasToken(false);
        }
      });
    } else {
      setError("Link invalido. Solicite um novo link de recuperacao de senha.");
    }
  }, []);

  // Validar senha forte
  const validatePassword = (pwd) => {
    const minLength = pwd.length >= 8;
    const hasUppercase = /[A-Z]/.test(pwd);
    const hasNumber = /[0-9]/.test(pwd);
    const hasSymbol = /[!@#$%^&*(),.?":{}|<>]/.test(pwd);
    
    if (!minLength) return "Senha deve ter no minimo 8 caracteres";
    if (!hasUppercase) return "Senha deve ter pelo menos 1 letra maiuscula";
    if (!hasNumber) return "Senha deve ter pelo menos 1 numero";
    if (!hasSymbol) return "Senha deve ter pelo menos 1 simbolo (!@#$%^&*...)";
    
    return null;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");

    // Validar senhas iguais
    if (password !== confirmPassword) {
      setError("As senhas nao coincidem");
      return;
    }

    // Validar senha forte
    const passwordError = validatePassword(password);
    if (passwordError) {
      setError(passwordError);
      return;
    }

    setLoading(true);

    try {
      const { error: updateError } = await supabase.auth.updateUser({
        password: password
      });

      if (updateError) {
        setError("Erro ao redefinir senha: " + updateError.message);
        setLoading(false);
        return;
      }

      // Sucesso - fazer logout e redirecionar
      await supabase.auth.signOut();
      setSuccess(true);
      
      // Redirecionar apos 3 segundos
      setTimeout(() => {
        navigate("/acesso-interno-bt", { 
          state: { message: "Senha redefinida com sucesso! Faca login com a nova senha." }
        });
      }, 2000);

    } catch (err) {
      setError("Erro ao processar requisicao. Tente novamente.");
      setLoading(false);
    }
  };

  return (
    <>
      {/* Meta tags para nao indexar */}
      <head>
        <meta name="robots" content="noindex, nofollow" />
      </head>
      
      <div style={{
        minHeight: "100vh",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        backgroundColor: "#f5f5f5",
        padding: "20px"
      }}>
        <div style={{
          backgroundColor: "white",
          padding: "40px",
          borderRadius: "8px",
          boxShadow: "0 2px 10px rgba(0,0,0,0.1)",
          width: "100%",
          maxWidth: "400px"
        }}>
          <h1 style={{
            fontSize: "14px",
            color: "#666",
            textAlign: "center",
            marginBottom: "30px",
            fontWeight: "normal",
            letterSpacing: "2px"
          }}>
            ACESSO RESTRITO
          </h1>

          <h2 style={{
            fontSize: "20px",
            color: "#333",
            textAlign: "center",
            marginBottom: "30px"
          }}>
            Redefinir Senha
          </h2>

          {success ? (
            <div style={{
              backgroundColor: "#d4edda",
              color: "#155724",
              padding: "15px",
              borderRadius: "4px",
              textAlign: "center"
            }}>
              Senha redefinida com sucesso!<br />
              Redirecionando para o login...
            </div>
          ) : !hasToken ? (
            <div style={{
              backgroundColor: "#f8d7da",
              color: "#721c24",
              padding: "15px",
              borderRadius: "4px",
              textAlign: "center"
            }}>
              {error || "Link invalido ou expirado."}
              <br /><br />
              <a 
                href="/acesso-interno-bt" 
                style={{ color: "#721c24", textDecoration: "underline" }}
              >
                Voltar para o login
              </a>
            </div>
          ) : (
            <form onSubmit={handleSubmit}>
              {error && (
                <div style={{
                  backgroundColor: "#f8d7da",
                  color: "#721c24",
                  padding: "10px",
                  borderRadius: "4px",
                  marginBottom: "20px",
                  fontSize: "14px"
                }}>
                  {error}
                </div>
              )}

              <div style={{ marginBottom: "20px" }}>
                <label style={{
                  display: "block",
                  marginBottom: "5px",
                  fontSize: "14px",
                  color: "#333"
                }}>
                  Nova senha
                </label>
                <input
                  type="password"
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  placeholder="Minimo 8 caracteres"
                  disabled={loading}
                  style={{
                    width: "100%",
                    padding: "12px",
                    border: "1px solid #ddd",
                    borderRadius: "4px",
                    fontSize: "16px",
                    boxSizing: "border-box"
                  }}
                />
              </div>

              <div style={{ marginBottom: "20px" }}>
                <label style={{
                  display: "block",
                  marginBottom: "5px",
                  fontSize: "14px",
                  color: "#333"
                }}>
                  Confirmar nova senha
                </label>
                <input
                  type="password"
                  value={confirmPassword}
                  onChange={(e) => setConfirmPassword(e.target.value)}
                  placeholder="Digite novamente"
                  disabled={loading}
                  style={{
                    width: "100%",
                    padding: "12px",
                    border: "1px solid #ddd",
                    borderRadius: "4px",
                    fontSize: "16px",
                    boxSizing: "border-box"
                  }}
                />
              </div>

              <div style={{
                fontSize: "12px",
                color: "#666",
                marginBottom: "20px",
                lineHeight: "1.5"
              }}>
                A senha deve conter:
                <ul style={{ margin: "5px 0 0 20px", padding: 0 }}>
                  <li>Minimo 8 caracteres</li>
                  <li>1 letra maiuscula</li>
                  <li>1 numero</li>
                  <li>1 simbolo (!@#$%^&*...)</li>
                </ul>
              </div>

              <button
                type="submit"
                disabled={loading || !password || !confirmPassword}
                style={{
                  width: "100%",
                  padding: "12px",
                  backgroundColor: loading ? "#ccc" : "#333",
                  color: "white",
                  border: "none",
                  borderRadius: "4px",
                  fontSize: "16px",
                  cursor: loading ? "not-allowed" : "pointer"
                }}
              >
                {loading ? "Redefinindo..." : "Definir nova senha"}
              </button>

              <div style={{
                marginTop: "20px",
                textAlign: "center"
              }}>
                <a 
                  href="/acesso-interno-bt" 
                  style={{ 
                    color: "#666", 
                    fontSize: "14px",
                    textDecoration: "none"
                  }}
                >
                  Voltar para o login
                </a>
              </div>
            </form>
          )}
        </div>
      </div>
    </>
  );
}
